// Fixed traffic-light palette for the punctuality Ampel classes, in stacking order
// (on-time -> worse -> cancelled). Distinct from the cycling chartColors palette.
export const AMPEL_CLASSES = [
  { key: 'onTime', label: 'pünktlich (<6 min)', color: '#2e7d32' },
  { key: 'd6_15', label: '+6–15 min', color: '#fbc02d' },
  { key: 'd16_60', label: '+16–60 min', color: '#f57c00' },
  { key: 'd60plus', label: '>60 min', color: '#c62828' },
  { key: 'cancelled', label: 'Ausfall', color: '#616161' },
]
